<!-- eslint-disable vue/no-v-for-template-key -->
<template>
  <div class="c-sortable">
    <template v-for="(item, i) in sortableValue">
      <div
        v-show="!(item || {}).hide"
        :key="`divider-${i}`"
        :style="{ order: (i * 2) + 1 }"
        class="divider"
      >
        <!-- @slot Divider between each item -->
        <slot
          name="divider"
          :item="getItemScopeData(item, i)"
        />
      </div>

      <div
        v-show="!(item || {}).hide"
        :key="item[trackBy]"
        :sort-key="item[trackBy]"
        :sort-index="i"
        :style="{ order: (i * 2) + 2, zIndex: sortableValue.length - i }"
        :class="getItemClasses(i)"
        v-on="rootDragHandlers ? getDragHandlers(i) : {}"
      >
        <!-- @slot Content item -->
        <slot
          name="content"
          :item="getItemScopeData(item, i)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import SortableMixin from './mixins/SortableMixin'
/**
 * A sortable vertical list using drag n' drop.
 *
 * You can style the drag item being dragged with --selected (placeholder)
 * and --drag (element being dragged) class modifiers inside the unique class item definition
 * (see storybook example)
 *
 * You can lock the parent drag behaviour on children elements which has
 * the @pointerdown.stop handler definition
 *
 * You can also set the drag handlers on item children, allowing to only drag items when touching
 * on those sub elements.
 */

export default {
  name: 'CSortable',

  mixins: [ SortableMixin({ valueProp: 'value', updateEvent: 'input' }) ],
}
</script>

<style lang="scss">
@import './style.scss';
</style>
